(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      // 'top' (full two-row bar) | 'revealed' (condensed bar) | 'hidden'
      this.state = 'top';
      this.settling = false;
      this.settleTimer = null;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      // Passive: the scroll handler never calls preventDefault, so this lets the
      // browser scroll without waiting on it (smoother sticky reveal).
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      // Changing the bar's height moves the page under her. Reading that as
      // scrolling made the bar flip hidden/revealed/hidden three times on one
      // flick (Jenny 2026-07-30). Stand down while it resizes, then resync.
      if (this.settling) return;

      // Scrolling DOWN gets the page out of the way: the bar slides off.
      // Scrolling UP brings back the condensed single-row bar. The full
      // two-row header is the TOP OF PAGE state only: a tall bar mid-scroll
      // blocks too much of the screen (Jenny 2026-07-30).
      //
      // JITTER was 4px, which a trackpad clears without trying.
      const JITTER = 12;

      if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      } else if (this.state === 'top' && scrollTop < this.holdDistance()) {
        // The full header is still on screen, or she has only just scrolled
        // past it. Let it scroll away on its own. Making it sticky here would
        // yank it back to the top of the window first and only then slide it
        // out, which is the snap she saw on the way down.
        return;
      } else if (scrollTop > this.currentScrollTop + JITTER) {
        if (!this.preventHide) requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop - JITTER) {
        if (!this.preventReveal) requestAnimationFrame(this.reveal.bind(this));
      } else {
        return;
      }

      this.currentScrollTop = scrollTop;
    }

    // How far she has to scroll before the bar is allowed to collapse. It used
    // to be the bar's own height (~162px), which is barely a flick, so the fold
    // landed the moment she started reading (Jenny 2026-09-11, "it stutters when
    // the user scrolls down, especially inside a product listing"). HALF a
    // viewport is her pick: the bar survives a small scroll without staying so
    // long that it eats the screen on the way down.
    //
    // It also removes the worst symptom outright: folding at ~162px meant the
    // scroll correction had less room above it than it needed, so the page
    // clamped to 0 and threw her back to the very top. Half a screen leaves
    // room to give it back properly. Change the multiplier here to retune.
    holdDistance() {
      return Math.max(this.headerBounds.bottom || 0, window.innerHeight * 0.5);
    }

    // Anything that changes the bar's HEIGHT also moves the page under her, so
    // the scroll handler stands down until it has finished and then resyncs to
    // wherever the page actually ended up.
    settle() {
      this.settling = true;
      clearTimeout(this.settleTimer);
      this.settleTimer = setTimeout(() => {
        this.settling = false;
        this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      }, 420);
    }

    hide() {
      if (this.state === 'hidden') return;
      const fromTop = this.state === 'top';
      if (fromTop) this.settle();
      this.state = 'hidden';
      if (fromTop) {
        // It has already scrolled off screen on its own. Two things have to be
        // true here or the page lurches:
        //
        // 1. No slide. Going sticky pins it back to the top of the window, so
        //    an animated hide would slide it DOWN into view and straight back
        //    out, a flash of a bar nobody asked to see.
        // 2. No free scrolling. Folding takes ~105px out of a page she is in
        //    the middle of reading, and everything below slides up by that
        //    much while her finger is still. That is the "strange auto-scroll"
        //    (Jenny 2026-07-30). So: fold INSTANTLY, measure exactly how much
        //    shorter the page got, and give that scroll straight back. The
        //    content ends up precisely where it was.
        //
        // 3. Do not pay the same debt twice. Chrome's own scroll anchoring
        //    ALREADY shifts the page to keep content still when something above
        //    it shrinks, and it does so before this code gets to look. Measured
        //    on a product page: scroll 180 -> the fold -> Chrome moved it to 84
        //    on its own -> this handed back another 96 -> 0, dumping her at the
        //    very top of the page with the content lurching 84px (Jenny
        //    2026-09-11, "it stutters when the user scrolls down"). So measure
        //    what Chrome already did and only make up the shortfall.
        const before = this.header.offsetHeight;
        const scrollBefore = window.pageYOffset || document.documentElement.scrollTop;
        this.header.classList.remove('animate');
        this.header.classList.add('fj-header-instant', 'shopify-section-header-hidden', 'shopify-section-header-sticky');
        const after = this.header.offsetHeight; // reading this applies the fold now
        const scrollAfter = window.pageYOffset || document.documentElement.scrollTop;
        const shrank = before - after;                     // height the page lost
        const alreadyGivenBack = scrollBefore - scrollAfter; // what Chrome handled
        const owed = shrank - alreadyGivenBack;
        if (owed > 0) window.scrollBy(0, -owed);
        requestAnimationFrame(() => requestAnimationFrame(() => {
          this.header.classList.remove('fj-header-instant');
          if (this.state === 'hidden') this.header.classList.add('animate');
        }));
      } else {
        // 'animate' keeps the slide-out smooth; without it the bar snaps away.
        this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      }
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.state === 'revealed') return;
      this.state = 'revealed';
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      // Every state change is guarded: the old code rewrote the class list on
      // EVERY scroll event, 60+ writes on one flick.
      if (this.state === 'top') return;
      this.state = 'top';
      this.settle();
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate', 'fj-header-instant');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Desktop nav hover animation
  (function() {
    function initHoverNav() {
      const headerMenus = document.querySelectorAll('header-menu');
      headerMenus.forEach(function(menu) {
        const details = menu.querySelector('details');
        if (!details) return;
        menu.addEventListener('mouseenter', function() {
          headerMenus.forEach(function(other) {
            if (other !== menu) other.querySelector('details').classList.remove('is-open');
          });
          details.classList.add('is-open');
        });
        menu.addEventListener('mouseleave', function() {
          details.classList.remove('is-open');
        });
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initHoverNav);
    } else {
      initHoverNav();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
